import { Dispatch } from "redux";
import { setMessagingTemplatesLoading, setMessagingTemplates } from "@redux/actions/messaging-templates-actions";
import { logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";
import { AxnCompany, AxnRelyingParty } from "@idw-types/data/reference-data/axn";
import { FormattedMessagingTemplateConfiguration } from "@idw-types/data/messaging-template";
import { formatMessagingTemplateConfigurations } from "@formatters/messaging-template-configurations/messaging-template-configuration-formatter";
import { getMessagingTemplatesRequest } from "@requests/axnadmin-core/get-messaging-templates";

export const getMessagingTemplatesReduxRequest = (dispatch: Dispatch) => async (
    axnCompanies: Array<AxnCompany>,
    axnRelyingParties: Array<AxnRelyingParty>
): Promise<Array<FormattedMessagingTemplateConfiguration>> => {
    dispatch(setMessagingTemplatesLoading(true));
    const { data, error } = await getMessagingTemplatesRequest();
    if (data?.messagingTemplates) {
        const formattedMessagingTemplates = formatMessagingTemplateConfigurations(data.messagingTemplates, axnCompanies, axnRelyingParties);
        dispatch(setMessagingTemplates(formattedMessagingTemplates));
        return formattedMessagingTemplates;
    } else {
        if (error) {
            logAndDisplayErrorModal(
                dispatch,
                error,
                resources.requests.getMessagingTemplates.error.title,
                resources.requests.getMessagingTemplates.error.message
            );
        }
        dispatch(setMessagingTemplatesLoading(false));
        return null;
    }
};